<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon icon-content"
              >
                <font-awesome-icon icon="plane-circle-exclamation" />
              </span>
            </template>
            <h3>{{ detailData.plan }}</h3>
          </div>
          <div class="mg-b-8">

            <span class="header-date">Created  <span class="number-color number-fontsize">{{ detailData.created_date }}</span></span>
            <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_date }}</span></span>
          </div>
          <div class="mg-b-20">
            <span class="header-date">Reference <span class="number-color number-fontsize">{{detailData.order_sn?`#${detailData.order_sn}`:''}}</span></span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!edit"
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">
          <div class="detail ">
            <div class="detail_title flex-sb-center">
              <span>Details</span>
            </div>
            <el-alert
              class="mg-b-20"
              type="info">
              <template slot="title">
                <ul class="tip-box ">
                  <li>Flight information is sourced from the Hong Kong Airport Authority. The system determines whether a flight is delayed based on the information provided by the Authority. <a
                    target="_blank"
                    class="blue text-decoration-none—inline"
                    href="https://www.hongkongairport.com/tc/contact-us/historical-flights.page">Flight Inquiry >></a></li>
                  <li><a
                    target="_blank"
                    href="https://www.flightaware.com/"
                    class="blue text-decoration-none—inline">FlightAware</a> Global Flight Information Inquiry (for reference only)</li>
                </ul>
              </template>
            </el-alert>
            <div
              v-for="(item,index) in traveller_detail"
              :key="index"
              class="table">
              <div class="th flex-sb-center">
                <span>
                  <span class="mg-r-10">
                    {{`${item.traveller_nm}`}}
                  </span>
                  <span class="gray-color">{{item.mobile_no}}</span>
                </span>
                <span
                  v-if="[0,5].includes(item.stts)"
                  class="blue hand"
                  @click="handleEdit(item,travelFlightData(index),index)">Edit</span>
              </div>
              <div class="tr">
                <span>Relationship</span>
                <span>{{travelFlightData(index).rel_language||'-'}}</span>
              </div>
              <div class="tr">
                <span>Last Updated</span>
                <span>{{ item.upload_date }}</span>
              </div>
              <div class="tr">
                <span>Flight No.</span>
                <span>{{item.flight_no||'-'}}</span>
              </div>
              <div class="tr dis-block">
                <span>Flight Ticket</span>
                <file-container
                  is-show-detail
                  is-viewer
                  :fileData="item.flight_ticket_pic" />
              </div>
              <!--              <template v-if="detailData.other_file&&detailData.other_file.length>0">-->
              <!--                <div-->
              <!--                  v-for="(item,index) in detailData.other_file"-->
              <!--                  :key="index"-->
              <!--                  class="tr">-->
              <!--                  <span>Other Document {{index+1}}</span>-->
              <!--                  <span-->
              <!--                    class="blue pointer"-->
              <!--                    @click="openFile(item)">{{item.client_name}}</span>-->
              <!--                </div>-->
              <!--              </template>-->

              <div class="tr">
                <span>Status</span>
                <span>
                  <span
                    class="span-status "
                    :class="{
                      'blue':[1].includes(item.stts),
                      'orange':[0].includes(item.stts),
                      'green':[2,3,4].includes(item.stts),
                      'gray':[5].includes(item.stts),
                    }"
                  >
                    {{item.stts_language}}
                  </span>
                  <span
                    v-if="[1].includes(item.stts)"
                    class="mg-t-8 block">
                    <v-button
                      green
                      :disabled="detailData.stts!=1"
                      @click="handleClaim(index,travelFlightData(index),item)"
                    >
                      <span>Claim Settle (HD 200)</span>
                    </v-button>
                  </span>
                </span>
                <!--                <span>{{detailData.stts_language||'-'}}</span>-->
              </div>
              <div class="tr">
                <span class="color-dark fw-600">Provided by the Airport Authority Hong Kong</span>
              </div>
              <div class="tr">
                <span>Departure Date</span>
                <span>{{item.anticipate_date||'-'}}</span>
              </div>
              <div class="tr">
                <span>Departure time</span>
                <span>{{item.anticipate_time||'-'}}</span>
              </div>
              <div class="tr">
                <span>Actual Departure time</span>
                <span class="color-red">{{`${item.actual_date} ${item.actual_time}`}}</span>
              </div>
            </div>
            <div class="table">
              <div class="th">
                Policy
              </div>
              <div class="tr">
                <span>Policy Name</span>
                <span>{{detailData.pcy_nm||'-'}}</span>
              </div>
              <div class="tr">
                <span>Effective Date</span>
                <span>{{detailData.effective_date||'-'}}</span>
              </div>
              <div class="tr">
                <span>Status & Tag</span>
                <span>
                  <p class="status-height">
                    <span
                      class="span-status"
                      :class="{
                        'red': [801, 0].includes(detailData.pcy_stts),
                        'orange': [401, 301].includes(detailData.pcy_stts),
                        'yellow-dark': [410, 501, 701].includes(detailData.pcy_stts),
                        'blue': [420, 505, 705].includes(detailData.pcy_stts),
                        'green': [425, 510, 710].includes(detailData.pcy_stts)
                      }">
                      {{ detailData.pcy_stts_language }}
                    </span>
                  </p>
                  <p
                    v-for="(v,i) in detailData.tag_language"
                    :key="'tag'+i"
                    class="status-height">
                    <span
                      class="span-options"
                      :class="{
                        'gold': v.id == 1,
                        'blue': [2,16,64,256].includes(v.id),
                        'orange': v.id == 4,
                        'black': [8,32,128].includes(v.id),
                        'red': [512].includes(v.id),
                        'gray': [1024, 2048].includes(v.id)
                      }">{{v.name}}</span>
                  </p>
                </span>
              </div>
              <div class="tr">
                <span>Ref#</span>
                <span class="blue">{{detailData.order_sn}}</span>
              </div>
            </div>
            <div class="table">
              <div class="th">
                Account Name
              </div>
              <div class="tr">
                <span>Last Name</span>
                <span>{{detailData.isrd_lst_nm}}</span>
              </div>
              <div class="tr">
                <span>First Name</span>
                <span>{{detailData.isrd_fst_nm}}</span>
              </div>
              <div class="tr">
                <span>Mobile Number</span>
                <span>{{detailData.mobile_no}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right-col">
          <div class="">
            <div
              class="btn-list "
            >
              <span
                class="title">Support</span>
              <div
                class="button-width mg-t-8">
                <span  class="mg-t-15 block">
                  <v-button
                    gray
                    class="mg-t-15"
                    @click="handleBack"
                  >
                    <span>Back</span>
                  </v-button>
                </span>
              </div>
            </div>
            <div
              class="box">
              <span class="title">Customer</span>
              <div>
                <div class="flex flex-align-center">
                  <div class="customer-ava">
                    <img
                      :src="avt_pic"
                      alt="">
                  </div>
                  <span class="span-status">{{customer_profile.id_type==3?'Company':'Personal'}}</span>
                  <router-link
                    :to="{path:'/accounts/detail',query:{customer_id:customer_profile.id}}"
                    class="flex flex-wrap text-decoration-none">
                    <span
                      v-if="isShowName"
                      class="plan-name hand"
                    >{{ customer_profile.isrd_nm }} &nbsp;</span>
                    <span
                      v-else
                      class="plan-name hand unname"
                    >Unnamed Account &nbsp;</span>
                  </router-link>
                </div>
                <ul>
                  <li>
                    <span>Joined</span>
                    <span>{{ customer_profile.created_at }}</span>
                  </li>
                  <li>
                    <span>Policy Count</span>
                    <span>{{ customer_profile.policys }}</span>
                  </li>
                  <li>
                    <span>Tags</span>
                    <span>
                      <div
                        v-if="customer_profile.upload_request_stts == 1 || customer_profile.is_tier_base || customer_profile.referral_coupon || customer_profile.referral_discount"
                        class="tag">
                        <div
                          v-if="customer_profile.upload_request_stts == 1"
                          class="span-tag unread-uplod">Unread Upload</div>
                        <div
                          v-if="customer_profile.is_tier_base"
                          class="span-tag professional-status">Professional</div>
                        <div
                          v-if="customer_profile.referral_coupon"
                          class="span-tag coupon-status">Custom Coupon</div>
                        <div
                          v-if="customer_profile.referral_discount"
                          class="span-tag discount-status">Custom Discount</div>
                      </div>

                      <div
                        v-if="customer_profile.verify_language"
                        class="tag">
                        <div
                          class="span-tag"
                          :class="{
                            'verified': customer_profile.verified == 20,
                            'pending_verify ': customer_profile.verified == -1,
                            'not_verify': customer_profile.verified == -2
                          }">{{ customer_profile.verify_language }}</div>
                      </div>

                      <div
                        v-if="customer_profile.is_flagged"
                        class="tag">
                        <div class="span-tag unread-uplod">
                          Flagged
                        </div>
                      </div>
                      <div
                        v-if="has_block_data"
                        class="tag">
                        <div class="span-tag not_verify">
                          Blocked
                        </div>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
              <contact-customer
                :customerId="customer_profile.id"
                :phone="customer_profile.phone"
                :customerName="detailData.isrd_nm"
                :email="customer_profile.send_email" />
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <flight-delay-form
      v-else
      :id="id"
      :from="flightData"
      :remark="remarkList"
      @success="handleRefresh"
      @cancel="handleCancel"></flight-delay-form>
    <claim-settle-dialog
      v-model="showClaim"
      :form="settleData"
      :detail-data="detailData"
      @refresh="handleRefresh"></claim-settle-dialog>
  </section>
</template>

<script>
import flightDelayForm from './flight-delay-form'

import {addFlightDelayRemark, getFlightDelayDetail} from '@/api/flightDelay'
import MixinOptions from '@/mixins/options'
import ContactCustomer from '@/views/components/new-contact-customer'
import ClaimSettleDialog from '@/views/records/micropolicy/components/flightDelay/claim-settle-dialog'
export default {
  name: 'flightDelayDetail',
  components:{
    ContactCustomer,
    ClaimSettleDialog,
    flightDelayForm
  },
  mixins: [MixinOptions],
  data () {
    return {
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      edit:false,
      showClaim:false,
      flightData:{},
      settleData:{},
    }
  },
  computed:{
    id(){
      return this.$route.params.id
    },
    isShowName(){
      let {isrd_nm,id_type} = this.customer_profile
      if(isrd_nm)
        return isrd_nm.trim()!=''
      else return  false
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    selectData(){
      return [this.id]
    },
    customer_profile(){
      let {customer_profile} = this.detailData||{}
      return customer_profile||{}
    },
    nm_traveler_list(){
      let {nm_traveler_list} = this.detailData||{}
      return nm_traveler_list||[]
    },
    traveller_detail(){
      let {traveller_detail} = this.detailData||{}
      return traveller_detail||[]
    },
    avt_pic(){
      let {avatar_pic} = this.customer_profile||{}
      return avatar_pic || null
    },

  },
  watch:{
    id:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getFlightDelayDetail()
        }
      }
    },
  },
  methods: {
    travelFlightData(index){
      return this.nm_traveler_list.length>0?this.nm_traveler_list[index]||{}:{}
    },
    openFile({url}) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    handleClaim(num,data,item){
      this.settle_num = num
      this.settleData = {...data,num,...item}
      this.showClaim = true
    },
    handleBack(){
      this.$router.back()
    },
    handleCancel(){
      this.edit = false
    },
    handleUpdateStatus(){
      this.isShow = true
    },
    handleEdit(data,flightData,num){
      this.flightData = {...data,...flightData,num}
      this.edit = true
    },
    handleRefresh(){
      this.network().getFlightDelayDetail()
    },
    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },
    network(){
      return{
        getFlightDelayDetail: async () => {
          const {data} = await getFlightDelayDetail({
            id: this.id
          })
          this.detailData = data
          this.remarkList = data.remark_list
        },
        addRemark: async () => {
          const {data} = await addFlightDelayRemark({
            id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.push(data)
        },

      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }


  .yellow{
    background-color: #DBAB09;
  }
  .red{
    border: 1px solid #CB2431;
    background: #fff;
    color: #D73A49!important;
  }
  .black{
    border: 1px solid #6A737D;
    background: #fff;
    color: #24292E!important;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: white!important;
  }
  .orange {
    background: #E36209;
  }
  .void{
    background: #d73a49;
  }
  .main-container {
    padding: 0 88px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .detail_title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-bottom: 20px;
    }
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }
    .buy-quote-container{
      flex: 1;
    }
    .middle-col {
      flex: 1;
      min-width: 600px;

      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .renew_list{
        margin-bottom: 20px;
        p{
          align-items: center;
          cursor: pointer;
          margin-bottom: 10px;
          .icon{
            width: 22px;
            height: 22px;
            background: #E1E4E8;
            border-radius: 5px;
          }
          .money{
            color: #0366D6;
            font-weight: 400;
            font-size: 16px;
          }
          .amount_tag{
            padding: 3px 12px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 12px;
            font-family: 'Inter';
            font-style: normal;
            margin-left: 15px;
            background: #FFFFFF;
            white-space: nowrap;
          }
          .tag_auto{
            border: 1px solid #0366D6;
            color: #0366D6;
          }
          .tag_terms{
            border: 1px solid #E1E4E8;
            color: #586069;
          }
          .active{
            font-weight: 600;
            font-size: 20px;
            color: #24292E;
          }
        }
        .cursor_default{
          cursor: default;
        }
        .btn{
          .el-button{
            flex: 1;
          }
        }
      }
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        .status{
          color: #68C23A
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        .percent{
          padding: 0px 6px;
          background: rgba(27, 31, 35, 0.08);
          border-radius: 100px;
          height: 16px;
          font-weight: 600;
          font-size: 12px;
          color: #586069;
          margin-left: 4px;
        }
      }
      .success{
        color: rgba(255, 255, 255, 1);
        background: rgba(46, 164, 79, 1);
      }
      .tr{
        display: flex;
        .mg-r-8{
          margin-right: 8px !important;
        }
      }
      .blue{
        color: #0366D6!important;
      }
      .bank-pay{
        margin-bottom: 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266!important;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-radius: 15px;
        border: 1px solid rgba(176, 136, 0, 0.2);

        .title {
          margin-top: 10px;
          margin-bottom: 5px;
        }
      }


      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .mt-10{
    margin-top: 10px;
    display: inline-block;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 88px 0px 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .pdb-10{
    padding-bottom: 10px;
  }

  .table {
    //border: 1px solid #E1E4E8;
    &.table_no_title{
      .tr:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border: 1px solid #E1E4E8;
      }
    }
    .table_tr_border0{
      .tr:last-child{
        border-radius: 0!important;
      }
    }
    .th{
      padding: 16px;
      background: $gray;
      border: 1px solid #E1E4E8;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: $dark!important;
      font-weight: 600;
      font-size: 14px;
      .gray-color{
        color: #677FA1;
      }
    }
    .tr {
      padding: 8px 16px;
      border: 1px solid #E1E4E8;
      border-top: 0;
      background: #fff!important;
      display: flex;
      align-items: center;

      /* Text/text-gray */
      &.dis-block{
        display: block;
      }
      color: #586069;
      &.tr-gray__title{
        background: $gray!important;
        span{
          color: #24292E!important;
        }
        .key-alt-down{
          color: #0366D6!important;
          cursor: pointer!important;
        }
      }
      span{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #586069;
        &:nth-child(2){
          color: #24292E!important;
          &.blue{
            color: #0366D6!important;
          }
          &.key-alt-down{
            color: #0366D6!important;
            cursor: pointer!important;
          }
        }
        .btn-green{
          span{
            color: #fff!important;
          }
        }
      }
      .blue{
        color: #0366D6!important;
      }
      .fw-600{
        font-weight: 600;
      }
      .top-algin{
        align-self: baseline;
      }
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
      &:nth-child(2n){
        background: #fff;
      }
      &:last-child{
        //border: 0;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      .span-status{
        &.blue {
          background: #0366D6!important;
          color: #fff!important;
        }
      }
    }
  }
}
.span-status{
  color: #fff!important;
  padding: 1px 8px;
  border-radius: 100px;
  margin-right: 15px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  &.blue {
    background: #0366D6!important;
    color: #fff!important;
  }
  &.gray{
    background: $gray60!important;
    color: #fff!important;
  }
}
.mg-b-20{
  margin-bottom: 20px;
}
.status-height{
  height: 23px;
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
      color: white!important;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    min-height: 18px !important;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
}
/deep/.file-box__detail{
  .flex-sb{
    justify-content: flex-start;
  }
  .flex-column{
    width: 50%;
  }

}
.color-red{
  color: #CB2431!important;
}
.tip-box{

}
</style>
